// Copyright ©️ 2026 eVolve MEP, LLC

import React from 'react';

import type { VDCOSChartToolType, EventsByFeature, UserId, TimeFrameData } from '@evolvemep/api-ts';

import { useGeneralContext } from 'helpers/useGeneralContext';

export const chartToolTypeLabels = {
  Evolve: 'EVOLVE Usage',
  Revit: 'Revit Usage',
} as const satisfies Record<VDCOSChartToolType, string>;

export type VDCOSChartOptionalFilters = {
  selectedRevitYear: string | null;
  userIds: UserId[];
  featureTypeNames: EventsByFeature['featureTypeName'][];
};

export type VDCOSChartFilters = VDCOSChartOptionalFilters & {
  toolType: VDCOSChartToolType;
  // Populated via global Time Frame filter
  timeFrame: TimeFrameData;
};

export const ChartFiltersContext = React.createContext<VDCOSChartFilters | undefined>(undefined);

export const useChartFilters = () => useGeneralContext(ChartFiltersContext, 'ChartFilters');
